import withAemIntegration from "../../../withAemIntegration";
import loadable from "../../../utils/loadable";
const Component = loadable(() =>
  import("@lexus.com/ui/dist/modules/InfoLayer")
);

const InfoLayerEditConfig = {
  emptyLabel: "Infolayer Component",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const transformData = (props) => ({
  ...props,
  model: props.heading,
  tabs: props?.tabs?.map((e) => ({
    ...e,
    panel: {
      ...e.panel,
      props: {
        ...e.panel?.props,
        stylesComponentReference: "model_styles",
      },
    },
  })),
});

const InfoLayer = (props) => {
  const data = transformData(props);
  return <Component {...data} />;
};

export default withAemIntegration(
  "lexus/components/infolayer/infolayer-component"
)(InfoLayer, InfoLayerEditConfig);
